// extracted by mini-css-extract-plugin
module.exports = {"infoIcon":"_7f6a2ebf","infoItem":"_618881e1","infoTextPrimary":"_c67a3225","infoTextSecondary":"_657b40d3"};